

















import { Vue, Component } from "vue-property-decorator";
import PracticeForm from "@/components/practice/PracticeForm.vue";
import api from "@/getinfo-api";
import { Practice as IPractice } from "@/api/models/practice";

@Component({
  components: { PracticeForm }
})
export default class PracticeEdit extends Vue {
  practice!: IPractice;
  data() {
    return {
      practice: undefined
    };
  }

  created() {
    api.PracticeApi.get(this.$route.params.courseId).then(
      (res: { data: IPractice }) => {
        if (res.data) {
          this.practice = res.data;
          document.title += ` ${this.practice.title}`;
        }
      }
    );
  }
}
